module.exports = __webpack_public_path__ + "img/img2.fa587a7a.png";